export default __webpack_public_path__ + "5a938beff9ebcca8f69521ffb912c8f2.png";